import * as api from '../api/agent-policies.js';
import { createEntityCache } from '../invalidation.js';
import q from '../query.js';
export const agentPoliciesEntity = 'agent-policies';
export const agentPoliciesCache = createEntityCache(agentPoliciesEntity);
const policiesKey = 'agent-policies';
export const useToolPolicies = () => q.query(policiesKey, () => api.listPolicies(), agentPoliciesCache.keys.collection);
//# sourceMappingURL=index.js.map